import React from "react";
import { Grid, Typography } from "@mui/material";


const TableHead = ({ 
    columnSizes, 
    showExclusiones, 
    showInicio,
    showFin,
    // showColPeriodo,
    showCoeficienteUnificado
}) => {
    const mostrarCoeficiente = showCoeficienteUnificado !== undefined ? showCoeficienteUnificado : true;

    return (
        <Grid
            container
            backgroundColor="#fff"
            p={1}
            py={1.7}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            borderRadius={1}
        >
            <Grid item xs={columnSizes.provincia}>
                <Typography variant="button" color="primary">
                    Provincia
                </Typography>
            </Grid>
            {showInicio && (
                <Grid item xs={columnSizes.inicio}>
                    <Typography variant="button" color="primary">
                        Inicio
                    </Typography>
                </Grid>
            )}
            {showFin && (
                <Grid item xs={columnSizes.fin}>
                    <Typography variant="button" color="primary">
                        Fin
                    </Typography>
                </Grid>
            )}
            {mostrarCoeficiente && (
                <Grid item xs={columnSizes.coeficienteUnificado}>
                    <Typography variant="button" color="primary">
                        C. Unificado
                    </Typography>
                </Grid>
            )}
            <Grid item xs={columnSizes.percepcion}>
                <Typography variant="button" color="primary">
                    Percepción
                </Typography>
            </Grid>
            {showExclusiones && (
                <>
                    <Grid item xs={columnSizes.exencion}>
                        <Typography variant="button" color="primary">
                            % Exención
                        </Typography>
                    </Grid>
                    <Grid item xs={columnSizes.vtoExencion}>
                        <Typography variant="button" color="primary">
                            Vto Exención
                        </Typography>
                    </Grid>
                </>
            )}
            <Grid item xs={columnSizes.acciones}>
                <Typography variant="button" color="primary">
                    Acciones
                </Typography>
            </Grid>
        </Grid>
    );
};

export default TableHead;

